/**
 * 折扣規則 Schema (SSOT)
 * 使用 Zod Discriminated Union 定義規則結構
 */
import { z } from 'zod';
/**
 * 百分比規則
 * 例如：10% off（打九折）
 */
const PercentageRuleSchema = z.object({
    ruleType: z.literal('PERCENTAGE'),
    config: z.object({
        rate: z.number().int().min(0).max(100).describe('折扣百分比：10 代表 10% off（打九折）'),
    }),
});
/**
 * 固定金額規則
 * 例如：減 100 元
 */
const FixedAmountRuleSchema = z.object({
    ruleType: z.literal('FIXED_AMOUNT'),
    config: z.object({
        amount: z.number().int().min(1).describe('折扣金額（元）'),
        minSpend: z.number().int().min(0).default(0).optional().describe('最低消費門檻（元，可選）'),
    }),
});
/**
 * BOGO 規則（買X送Y）
 * 例如：買一送一、第二件六折
 */
const BogoRuleSchema = z.object({
    ruleType: z.literal('BOGO'),
    config: z.object({
        buyQuantity: z.number().int().min(1).describe('買幾件（門檻）'),
        getQuantity: z.number().int().min(1).describe('送幾件（優惠區段）'),
        discountPercentage: z.number().int().min(0).max(100).describe('折扣百分比：100 = 免費，40 = 打六折'),
        scope: z.enum(['SINGLE_PRODUCT', 'CROSS_PRODUCT']).default('SINGLE_PRODUCT').describe('適用範圍：單一品項或跨品項'),
        targetProductIds: z.array(z.string().uuid()).optional().describe('跨品項時指定商品列表（可選）'),
        targetProductId: z.string().uuid().optional().describe('贈送商品 ID（可選）：如果指定，表示「買A送B」；如果不指定，表示「買A送A」'),
    }),
});
/**
 * 折扣規則配置 Discriminated Union
 * 根據 ruleType 自動推導 config 結構
 */
export const DiscountRuleConfigSchema = z.discriminatedUnion('ruleType', [
    PercentageRuleSchema,
    FixedAmountRuleSchema,
    BogoRuleSchema,
]);
/**
 * 規則類型枚舉
 */
export const DiscountRuleTypeSchema = z.enum(['PERCENTAGE', 'FIXED_AMOUNT', 'BOGO']);
/**
 * 適用範圍類型枚舉
 */
export const DiscountTargetTypeSchema = z.enum(['ALL', 'CATEGORY', 'PRODUCT']).describe('適用範圍類型：ALL（全館）、CATEGORY（特定分類）、PRODUCT（特定商品）');
